<template>
  <div
    v-show="visible"
    class="accordion"
    :class="{ full: full, 'no-border': noBorder, 'not-permitted': !permitted }"
  >
    <el-collapse v-model="activeNames" @change="onExpand">
      <el-collapse-item :key="id" name="1" :disabled="!permitted" >
        <template slot="title">
          <div
            v-if="(full && dirButtonLeft) || level == 'state'"
            class="accordion__title-right"
            :class="{ 'no-left-margin': noLeftMargin }"
          >
            <AccordionButton
              v-if="(full && dirButton) && permitted"
              :direction="isDown ? 'prev-down' : 'prev-up'"
              :icon="isDown ? 'arrow-up--red' : 'arrow-down--red'"
            />

            <Info
              v-if="full && info"
              :text="'Last update ' + fixDate"
              :arrow="false"
            />
          </div>
          <!-- The requirements pages show country flags -->
          <Country v-if="iso" :iso="iso" size="smallpadded" :icon="flag" />
          <slot name="title">
          <TitleBlock
            v-if="full"
            :text="title"
            color="white"
            :size="size"
            :link="seeAll"
            :padding="false"
          />

          <TitleVx v-else-if="!full && !link" :text="title" :size="'small'" />
          <nuxt-link v-else :to="link" class="title-link">
            {{ title }}
          </nuxt-link>
          </slot>
          <div v-if="!dirButtonLeft" class="accordion__title-right">
            <AccordionButton
              v-if="(full && dirButton) && permitted"
              :direction="isDown ? 'prev-down' : 'prev-up'"
              :icon="isDown ? 'arrow-up--red' : 'arrow-down--red'"
            />
            <Tip
              v-if="tip"
              :tip-content="tipContent"
              class="tip-button-report"
            />
            <Info
              v-if="full && info"
              :text="'Last update ' + fixDate"
              :arrow="false"
            />
          </div>
        </template>
        <div class="inner-accordion">
          <slot />
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { months } from "../../config";
export default {
  name: "Accordion",
  components: {
    TitleBlock: () => import("../elements/TitleBlock"),
    TitleVx: () => import("../elements/Title"),
    Info: () => import("../elements/Info"),
    AccordionButton: () => import("../elements/AccordionButton"),
    Country: () => import("../elements/Country"),
    Tip: () => import("../elements/Tip"),
  },
  props: {
    tip: {
      type: Boolean,
      default: false,
    },
    iso: {
      type: String,
      default: null,
    },
    full: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: null,
    },
    dirButton: {
      type: Boolean,
      default: false,
    },
    dirButtonLeft: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    noLeftMargin: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    tipContent: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: "",
    },
    seeAll: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: "default",
    },
    propsHandleEvent: {
      type: Function,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
    pid: {
      type: Number,
      default: null,
    },
    jurisdictionParent: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    permitted: {
      type: Boolean,
      default: true,
    },
    level: {
      type: String,
      default: "",
    },
    flag: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isDown: false,
      months,
    };
  },
  computed: {
    activeNames: {
      get() {
        return this.active ? ["1"] : [];
      },
      set(val) {
        this.isDown = !!val.length;
      },
    },
    fixDate() {
      let date = "";
      if (this.info) {
        const text = this.info.trim();
        const newText = text.substring(0, 10).replace(/-/g, "/");
        const newDate = new Date(newText);
        const day = newDate.getDate();
        const month = newDate.getMonth();
        const year = newDate.getFullYear();
        const monthName = this.months.find((el) => el.id === month);
        if (monthName) date = day + " " + monthName.name + " " + year;
      }
      return date;
    },
  },
  watch: {
    active(val) {
      this.isDown = val;
    },
  },
  mounted() {
    this.isDown = this.active;
    // This could potentially be considered an onExpand 'event' but we're actually not performing an expansion but rather starting out expanded...
    if (this.active) {
      this.$emit(
        "initiallyExpanded",
        this.id,
        this.pid,
        this.jurisdictionParent,
        this.level
      );
    }
  },
  methods: {
    onExpand(e) {
      if (this.isDown) {
        this.$emit(
          "loadLicenses",
          this.id,
          this.pid,
          this.jurisdictionParent,
          this.level
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.el-icon-arrow-left,
.el-icon-arrow-right {
  color: red;
  font-weight: bold;
  font-size: 15px;
  font-style: normal !important;
}

.accordion.full .accordion__title-right .tip-button-report {
  position: absolute;
  right: 4.5rem;
  top: 1rem;
  width: 17px;
}

.accordion {
  .title-link {
    font-size: 2rem;
    font-weight: 700;
    color: $text_gray;
    text-decoration: none;
    transition: 0.3s ease-out;
    &:hover {
      color: $brightGreen;
    }
  }
  .el-collapse-item__content {
    border: none !important;
  }

  .el-collapse {
    border: none;
    position: relative;
    &-item {
      //margin-left: 4rem;
      &__header {
        //    margin-left: 4rem;
        // &:first-child {
        //   margin-left: none;
        // }
        min-height: 3.6rem;
        line-height: 3.6rem;
        height: auto;
        // border-bottom: 1px dotted $border;
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-right: 3.5rem;
        background-color: transparent;

        &:after {
          content: "";
          position: absolute;
          top: 1rem;
          right: 1.5rem;
          display: block;
          width: 1.2rem;
          height: 1.2rem;
          background: url("../../assets/icons/i_arrow-red.svg") no-repeat;
          background-size: contain;
          transform: rotate(-90deg);
          transition: 0.3s ease-out;
        }
        &.is-active {
          &:after {
            transform: rotate(90deg);
          }
        }
        .title {
          margin-bottom: 0;
          padding-right: 4rem;
          .title__text {
            line-height: 1.2;
          }
        }
        .info {
          margin-right: 1rem;
        }
      }
      &__wrap {
        //border-bottom: none;
        //border: 1px dotted $border;
        //border-left: 1px dotted $border;
        border-top: 1px dotted $border;
        background-color: transparent;
      }
      &__arrow {
        display: none;
      }
      &__content {
        border: 1px dotted $border;
        border-left: none;
        border-top: none;
        // padding: 2rem 2.6rem 1.6rem 0;
        a {
          color: $link-primary;
          text-decoration: none;
          &:hover {
            color: $link-primary-hover;
            text-decoration: underline;
          }
        }

        em,
        i {
          font-style: italic;
        }
      }
    }
  }
  &.full {
    .el-collapse {
      padding-top: 15px;
      &-item {
        border-bottom: 1px dotted $border;
        // border-right: 1px dotted $border;
        &__header {
          min-height: 3.6rem;
          line-height: 3.6rem;
          height: auto;
          // background: rgba(177, 179, 179, 0.5);
          // border-bottom: none;
          align-items: flex-start;
          padding-right: 0;
          &:after {
            display: none;
          }
        }
        &__content {
          border: none;
        }
      }
    }
    .accordion__title-right {
      line-height: 3.6rem;
      height: 3.6rem;
      position: relative;

      margin-left: 4rem;

      .info {
        position: absolute;
        right: 5rem;
        top: 0.8rem;
        @include below($md) {
          display: none;
        }
      }
    }
  }
  &.no-border {
    .el-collapse {
      &-item {
        &__content {
          border: none;
        }
      }
    }
  }
  &.not-permitted {
    .el-collapse {
      position: relative;
      &-item {
        &__header {
          opacity: 0.2;
          color: lighten($gray, 10%);;
        }
      }
    }
  }
  &:hover {
    .tooltip {
      display: block;
      position: absolute;
      transform: translate(-50%, -50%);
    }
  }
  &.no-left-margin {
    .accordion__title-right {
      margin-left: none;
    }
  }
  &__title {
    &-right {
      height: 100%;
    }
  }
}
.inner-accordion {
  li {
    font-size: 13px;
  }
  p {
    margin-top: 2rem;
    font-size: 13px;
  }
  a {
    color: $link-primary;
    text-decoration: none;

    &:hover {
      color: $link-primary-hover;
      text-decoration: underline;
    }
    u {
      color: $link-primary;
      text-decoration: none;
      &:hover {
        color: $link-primary-hover;
        text-decoration: underline;
      }
    }
  }
}
</style>
